import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { CommonModule, JsonPipe } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ListComponent } from '../../components/list/list.component';
import { HeaderComponent } from '../../components/header/header.component';
import { GlobalService } from '../../services/global.service';
import { SearchInputComponent } from '../../components/search-input/search-input.component';
import { ToggleTabsComponent } from '../../components/toggle-tabs/toggle-tabs.component';
import { ButtonComponent } from '../../components/button/button.component';
import { ConfirmationPopupComponent } from '../../components/confirmation-popup/confirmation-popup.component';
import { ModalComponent } from '../../components/modal/modal.component';
import { TextInputComponent } from '../../components/text-input/text-input.component';
import { PluralPipe } from '../../pipes/plural.pipe';
import { SelectInputComponent } from '../../components/select-input/select-input.component';
import { ListActionButtonsComponent } from '../../components/list-action-buttons/list-action-buttons.component';
import { AgGridListComponent } from '../../components/ag-grid-list/ag-grid-list.component';
import { DropdownService } from '../../services/dropdown.service';
import { DivisionService } from '../../services/division.service';
import { BulkUploadComponent } from '../../components/bulk-upload/bulk-upload.component';
import { FilterByKeyAndValuePipe } from '../../pipes/filter-by-key-and-value.pipe';

@Component({
  selector: 'app-division-list-page',
  imports: [ListComponent, HeaderComponent, SearchInputComponent, FilterByKeyAndValuePipe, ToggleTabsComponent, ButtonComponent, RouterLink, CommonModule, ConfirmationPopupComponent, JsonPipe, ModalComponent, TextInputComponent, ReactiveFormsModule, PluralPipe, SelectInputComponent, AgGridListComponent, SearchInputComponent, BulkUploadComponent, JsonPipe],
  templateUrl: './division-list-page.component.html',
})
export class DivisionListPageComponent {
  @ViewChild('confirmation_delete_modal') confirmation_delete_modal: ConfirmationPopupComponent | undefined;
  @ViewChild('confirmation_disabled_modal') confirmation_disabled_modal: ConfirmationPopupComponent | undefined;
  @ViewChild('form_modal') form_modal: ModalComponent | undefined;
  @ViewChild('view_modal') view_modal: ModalComponent | undefined;

  @ViewChild('bulk_modal') bulk_modal: any
  page_name = 'Division';
  form: FormGroup;
  params: any = {};
  selected_ids: any = {}
  items: any[] = [];
  isSubmitting = false;

  columns: any = [
    { headerName: 'Sr.No', field: 'SrNo', },
    { field: 'State.country.name', headerName: 'Country', filter: true, flex: 1, },
    { field: 'State.name', headerName: 'State', filter: true, flex: 1, },
    { field: 'name', headerName: 'Division', filter: true, flex: 1, },
    { field: 'code', headerName: 'Division Code', filter: true, flex: 1, },
    { headerName: "Actions", sortable: false, flex: 1, cellRenderer: ListActionButtonsComponent, headerClass: 'custom-header-center', cellRendererParams: { actions: this.actions.bind(this) }, editable: false, pinned: 'right', }
  ];

  bulk_columns = [
    { column_name: 'Country Name', type: 'link', linked_list: 'country_list', linked_from: 'country', return_as: 'country_id', returning_key: 'id', sample_value: 'India' },
    { column_name: 'State Name', type: 'link', linked_list: 'state_list', return_as: 'state_id', returning_key: 'id', sample_value: 'Maharashtra' },
    { column_name: 'Division Name', type: 'text', return_as: 'name', sample_value: 'Mumbai', is_unique: true },
    { column_name: 'Division Code', type: 'text', return_as: 'code', sample_value: 'Mumbai' },
    // { column_name: 'Status', type: 'text', return_as: 'is_active', sample_value: true },

  ];

  actions(row: any) {
    let actions: any = []
    actions.push({ text: 'Disable', shortcut: 'u', color: 'gray', icon: 'bx bx-block', function: this.disable.bind(this) })
    actions.push({ text: 'View', shortcut: 'u', color: 'sky', icon: 'bx bx-eye', function: this.open_view_modal.bind(this) })
    actions.push({ text: 'Update', shortcut: 'u', color: 'sky', icon: 'bx bx-edit', function: this.open_form_modal.bind(this) })
    actions.push({ text: 'Delete', shortcut: 'd', color: 'red', icon: 'bx bx-trash', function: this.open_delete_modal.bind(this) })
    return actions
  }

  constructor(public gs: GlobalService, public route: Router, public fb: FormBuilder, public ds: DivisionService, public ar: ActivatedRoute, public dds: DropdownService) {
    this.form = this.fb.group({
      country_id: ['', [Validators.required]],
      state_id: ['', [Validators.required]],
      name: ['', [Validators.required]],
      code: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(10), Validators.pattern('^[a-zA-Z0-9]+$')]],
      is_active: [true]
    });
  }

  async ngOnInit() {
    await this.dds?.get_dropdown_list(['country', 'state']);
    this.ar.queryParams.subscribe(async params => {
      this.params = { ...params }
    })
  }

  async get_list(filter?: any) {
    try {
      const res = await this.ds.get_list(filter);
      const page = filter?.page || 1;
      const pagesize = filter?.page_size || 10;
      const startindex = (page - 1) * pagesize;

      res.data = res.data.map((item: any, index: number) => ({
        ...item,
        SrNo: startindex + index + 1
      }));

      this.items = res;
    } catch (error: any) {
      console.error("Error fetching Booking list:", error);
    }
  }

  async open_delete_modal(item: any, index: any) {
    this.selected_ids = item;
    this.confirmation_delete_modal?.open();
  }

  async disable(item: any, index: any) {
    this.selected_ids = item;
    this.confirmation_disabled_modal?.open();
  }

  async delete() {
    try {
      let res = await this.ds.delete(this.selected_ids.id);
      this.gs.toastr_shows_function(res?.message, 'Success', 'success');
      this.selected_ids = {};
      this.confirmation_delete_modal?.close()
      this.dds.invalidate_dropdown_cache('division');
      await this.get_list(this.params);
    } catch (error: any) {
      this.gs.toastr_shows_function(error.error.message, 'Error', 'error');
    }
  }

  async update_country(item: any) {
    try {
      let form_value = this.form.value;
      let data = item == true ? form_value.is_active == false : form_value.is_active == true
      let update = await this.ds.update(this.selected_ids.id, { is_active: data });
      this.gs.toastr_shows_function('Status has been successfully updated', 'Success', 'success');
      this.confirmation_delete_modal?.close()
      this.dds.invalidate_dropdown_cache('division');
      await this.get_list(this.params);
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }

  open_view_modal(item: any) {
    console.log(item);
    this.selected_ids = item || {};
    this.view_modal?.open();
  }

  async bulk_delete(ids: any[]) {
    try {
      for (let id of ids) {
        let res = await this.ds.delete(id);
      }
      this.gs.toastr_shows_function('Records deleted successfully', 'Success', 'success');
      this.dds.invalidate_dropdown_cache('division');
      await this.get_list(this.params);
    } catch (error: any) {
      this.gs.toastr_shows_function(error.error.message, 'Error', 'error');
    }
  }

  async open_form_modal(item?: any) {
    this.selected_ids = item || {};
    if (this.selected_ids && this.selected_ids.id) {
      let response = await this.ds.get(item.id);
      this.selected_ids = this.gs.addHierarchyIds({ ...response.data })
      this.form.patchValue({ ...this.selected_ids, });
    } else {
      this.selected_ids = {};
      this.form.reset();
    }
    this.form_modal?.open();
  }

  close_form_modal(): void {
    this.form_modal?.close();
  }

  async submit() {
    if (this.isSubmitting) {
      return;
    }
    if (this.form.invalid) {
      this.gs.toastr_shows_function('Please fill all required fields correctly.', 'Error', 'error');
      this.form.markAllAsTouched();
      return;
    }
    this.isSubmitting = true;
    try {
      let form_value = this.form.value;
      form_value.is_active = true;
      delete form_value.country_id
      if (this.selected_ids && this.selected_ids.id) {
        let update_response = await this.ds.update(this.selected_ids.id, form_value);
        this.gs.toastr_shows_function('Changes updated successfully', 'Success', 'success');
      } else {
        let create_response = await this.ds.add(form_value);
        this.gs.toastr_shows_function(create_response?.message, 'Success', 'success');
      }
      this.dds.invalidate_dropdown_cache('division');
      await this.get_list(this.params);
      this.close_form_modal();
    } finally {
      this.isSubmitting = false;
    }
  }

  async bulk_upload(data: any, spinner: any) {
    try {
      const updatedData = data.map((item: any) => ({
        ...item,
        is_active: true
      }));
      await this.gs.bulk_form_submission(updatedData, this.ds, this.params, this.get_list.bind(this), this.bulk_modal, spinner)
    } catch (error: any) {
      console.error(error?.error?.message, '');
    }
  }
}
